export default __webpack_public_path__ + "static/media/goopter-use-case-hotel-service-automation-process.5fc9ab4c.png";